export const jobTypeOptions = [
    { value: "Select", label: "Select" },
    { value: "Full Time", label: "Full Time" },
    { value: "Probation", label: "Probation" },
    { value: "Contract", label: "Contract" },
    { value: "Hybrid", label: "Hybrid" },
  ];
  
